import React, { useState, useEffect, useMemo } from "react";
import Helmet from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import { Spinner } from "react-bootstrap";
import { permissionListApi, permissionMetaActiveListApi } from "store/actions";
import Table from "components/Table";
import Columns from "./Columns";
import FormikForm from "components/shared/FormikForm";
import AddUpdatePermission from "components/Modals/AddPermission";
import PermissionGate from "components/PermissionGate";
import usePermission from "hooks/usePermission";

const InputFieldsForSearch = [
  {
    name: "search",
    type: "text",
    label: "",
    placeholder: "Search...",
  }
];
const initialValuesForFilter = {
  search: "",
};

const List = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.Auth);
  const { permissionList, totalPermission, loading } = useSelector((state) => state.Permission);
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);
  const [showAddUpdatePop, setShowAddUpdatePop] = useState({
    show: false,
    rowData: null,
  });
  const [filter, setFilter] = useState({
    page: 1,
    limit: 20,
    order: -1,
    orderBy: "createdAt",
    search: "",
  });
  const { hasPermission } = usePermission();
  const permissions = useMemo(() => ({
    add: hasPermission("add_permission"),
    edit: hasPermission("edit_permission"),
    delete: hasPermission("delete_permission"),
  }), [hasPermission]);

  useEffect(() => {
    getApiData(filter);
  }, [filter]);

  useEffect(() => {
    setcolumns(
      Columns({ permissions, user })?.filter((item) => {
        return true;
      }),
    );
  }, [permissions.edit, permissions.delete, user?.role]);

  async function getApiData(query) {
    try {
      dispatch(permissionListApi({ data: query }));
    } catch (error) { }
  }

  const handleFilterForm = (info) => {
    setFilter({
      ...filter,
      page: 1,
      limit: 20,
      order: -1,
      orderBy: "createdAt",
      search: info.search
    });
  };

  const handleConfirmAddUpdate = () => {
    setShowAddUpdatePop({ show: false, rowData: null });
    getApiData(filter); // Refresh list
  };

  const handleOpenAddModal = () => {
    dispatch(permissionMetaActiveListApi());
    setShowAddUpdatePop({ show: true, rowData: null });
  };
  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      <Helmet title={"Permissions"} />
      {showAddUpdatePop.show && (
        <AddUpdatePermission
          show={showAddUpdatePop.show}
          title={showAddUpdatePop?.rowData ? "Update Permission" : "Add Permission"}
          loading={loading}
          handleClose={() => setShowAddUpdatePop({ show: false, rowData: null })}
          handleConfirm={handleConfirmAddUpdate}
          rowData={showAddUpdatePop?.rowData}
        />
      )}
      <section className="section">
        <div className="section-header">
          <h1>Permissions</h1>
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">Permission List</h2>
                </div>
              </div>
              <PermissionGate permission="add_permission">
                <div className="col-6">
                  <div className="card-header d-flex justify-content-end align-items-center">
                    <button
                      className="btn btn-primary"
                      onClick={handleOpenAddModal}>
                      Add Permission
                    </button>
                  </div>
                </div>
              </PermissionGate>
              <div className="col-12">
                <div className="card-header">
                  <FormikForm
                    initialValues={initialValuesForFilter}
                    onSubmit={handleFilterForm}
                    loading={loading}
                    inputFields={InputFieldsForSearch}
                    buttonText={"Search"}
                  />
                </div>
              </div>
            </div>
          </div>
          {loading && permissionList?.length === 0 && (
            <div className="d-flex justify-content-center align-items-center py-5">
              <Spinner animation="border" role="status" />
            </div>
          )}
          {permissionList?.length > 0 && (
            <Table
              data={permissionList}
              columns={columns}
              setFilter={setFilter}
              total={totalPermission}
              filter={filter}
            />
          )}
          {!loading && permissionList?.length === 0 && (
            <p style={{ textAlign: "center" }}>No Permission Found</p>
          )}
        </div>
      </section>
    </>
  );
};

export default List;
